import { PageHeader } from "@components/page/PageHeader"
import { defineBlock, EditableText, usePostExcerptEditor, usePostTitleEditor } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "TFF Ticketing Page Header",
  inserter: false,
  icon: "format-aside",
  category: "text",
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("tff-center/tff-center-tickets-header", (props) => {
  return (
    <PageHeader
      mixpanelArea="Page Header"
      // breadcrumbs={[
      //   {
      //     back: true,
      //     active: false,
      //     title: props.tffCenter?.title! + " Program",
      //     uri: `/program/${props.tffCenter?.slug!}`,
      //   },
      // ]}
      title={<EditableText store="title" defaultValue="Buying Tickets" plainText disableLineBreaks />}
      description={
        <EditableText
          store="description"
          allowedFormats={["core/italic", "core/bold", "core/link"]}
          defaultValue="Travelling Film Festival welcomes all sorts, from the one-flick wonder to the film connoisseur."
        />
      }
      theme="grey"
      image={props.image!}
      links={[]}
    />
  )
})
